import { render, staticRenderFns } from "./block-footer.vue?vue&type=template&id=ef5f10e4&scoped=true&"
import script from "./block-footer.vue?vue&type=script&lang=js&"
export * from "./block-footer.vue?vue&type=script&lang=js&"
import style0 from "./block-footer.vue?vue&type=style&index=0&id=ef5f10e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5f10e4",
  null
  
)

export default component.exports